// 确保在引入之前 loadVue3Dependencies

const getActualTarget = () => window.Vue3.Vue3;

module.exports = new Proxy({}, {
  get: (_, key) => {
    // CJS stub：webpack `__webpack_require__.n` 会读 `__esModule`。
    // 此时 Vue3 可能尚未就绪，不能转发到 getActualTarget。
    if (key === '__esModule') return false;
    return Reflect.get(getActualTarget(), key);
  },
  set: (_, key, value) => Reflect.set(getActualTarget(), key, value),
  has: (_, key) => Reflect.has(getActualTarget(), key),
  ownKeys: () => Reflect.ownKeys(getActualTarget()),
});
